import { ShieldMark } from "./Logo";

export type Tab = "wall" | "analyzer";

const TABS: { id: Tab; label: string }[] = [
  { id: "wall", label: "FEED" },
  { id: "analyzer", label: "CLASSIFY" },
];

export function Nav({ tab, onChange }: { tab: Tab; onChange: (t: Tab) => void }) {
  return (
    <header className="sticky top-0 z-40 border-b-[1.5px] border-ink bg-paper">
      <div className="flex h-10 items-stretch">
        <button
          onClick={() => onChange("wall")}
          className="flex items-center gap-2 border-r-[1.5px] border-ink px-3 hover:bg-pink"
        >
          <ShieldMark size={15} />
          <span className="mono text-[12px] font-bold tracking-tight">FENZ.AI</span>
        </button>

        {TABS.map((t) => (
          <button
            key={t.id}
            onClick={() => onChange(t.id)}
            className="mono border-r-[1.5px] border-ink px-4 text-[11px] tracking-[0.1em] transition-colors"
            style={{
              background: tab === t.id ? "var(--ink)" : "transparent",
              color: tab === t.id ? "var(--paper)" : "var(--ink)",
            }}
          >
            {t.label}
          </button>
        ))}

        <div className="flex-1" />

        <div className="mono hidden items-center gap-2 border-l-[1.5px] border-ink px-3 text-[11px] sm:flex">
          <span className="live-dot" />
          LIVE
        </div>
      </div>
    </header>
  );
}
